export default "__VITE_ASSET__kenFonT3__"